<template>
  <div class="modal-window uts004">
    <header class="modal-header">
      <div class="tit">{{$i18nUtil.trans("entity.todo","할 일")}}</div>
    </header>

    <div class="modal-content">
      <div class="tab_ty1" id="tabsTy3">
        <ul class="tab-menu">
          <li
            v-for="(tab, index) in tabsTy3"
            v-bind:class="{ active: currentTab3 === index }"
            :key="'tabsTy3_' + index"
          >
            <button type="button" @click="changeTab(index)">
              {{ tab }}
            </button>
          </li>
        </ul>
        <div class="tab-content">
          <div v-show="currentTab3 == 0">
            <div class="tab_ty2">
              <ul class="tab-menu">
                <li
                  v-for="(tab, index) in tabsTy4"
                  v-bind:class="{ active: currentTab4 === index }"
                  :key="'tabsTy4_' + index"
                >
                  <button type="button" @click="changeTab2(index)">
                    {{ tab }}
                  </button>
                </li>
              </ul>
              <div class="tab-content">
                <div v-show="currentTab4 == 0">
                  <div class="tb-header clear">
                    <div class="tb_sort fr">
                      <div class="calendar_box_grp small">
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            v-model="startDate"
                            :disabled-dates="startDisabledDate"
                          ></datepicker>
                        </div>
                        <span>~</span>
                        <div class="calendar_box" style="margin-left: 10px">
                          <datepicker
                            format="yyyy.MM.dd"
                            v-model="endDate"
                            :disabled-dates="endDisabledDate"
                          ></datepicker>
                        </div>
                        <div class="calendar_box hidden"></div>
                      </div>
                      <div class="dividing_line_ty1"></div>
                    </div>
                  </div>
                  <div class="decision-making todo clear col-2">
                    <div class="inner">
                      <div class="tit">
                        {{ $i18nUtil.trans("entity.todo.status.incomplete","미완료") }}
                        <b>{{ listFromMeElseCount }}</b>
                      </div>
                      <div class="list_wrap">
                        <div class="nodata" v-if="listFromMeElseCount == 0">
                          <div class="txt">{{$i18nUtil.trans("search.029","미완료된 할 일이 없습니다.")}}</div>
                        </div>
                        <div
                          class="list"
                          v-for="(fromElse, index) in listFromMeElse"
                          :key="'listFromMeElse' + index"
                          :transfer-data="fromElse"
                        >
                          <div class="checkbox">
                            <input type="checkbox" /><label
                              @click="complete(fromElse)"
                            ></label>
                          </div>

                          <div class="task_name flex flex-between">
                            <div class="flex-division">
                              <span v-if="fromElse.groupKbn == 'CFRC' && fromElse.paperId == ''">{{ $i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의") }} </span>
                              <span v-if="fromElse.groupKbn == 'CFRC' && fromElse.paperId == ''" class="cate-tit ell-singleline">{{ fromElse.categoryName }}</span>
                              <span v-if="fromElse.groupKbn == 'CFRC' && fromElse.paperId != ''">{{ $i18nUtil.trans("entity.paper","보드") }} </span>
                              <span v-if="fromElse.groupKbn == 'CFRC' && fromElse.paperId != ''" class="cate-tit ell-singleline" 
                                @click="moveLocation('PAPER', fromElse.paperId)">{{ fromElse.paperTitle }}
                              </span>
                              <span v-if="fromElse.groupKbn == 'PRO' && fromElse.paperId == ''">{{$i18nUtil.trans("entity.project","과제")}} </span>
                              <span v-if="fromElse.groupKbn == 'PRO' && fromElse.paperId == ''" class="cate-tit ell-singleline" 
                                @click="moveLocation(fromElse.groupKbn, fromElse.projectId)">{{ fromElse.projectName }}
                              </span>
                              <span v-if="fromElse.groupKbn == 'PRO' && fromElse.paperId != ''">{{ $i18nUtil.trans("entity.paper","보드") }} </span>
                              <span v-if="fromElse.groupKbn == 'PRO' && fromElse.paperId != ''" class="cate-tit ell-singleline"
                                @click="moveLocation('PAPER', fromElse.paperId)">{{ fromElse.paperTitle }}
                              </span>
                              <span v-if="fromElse.groupKbn == 'USER'">{{ $i18nUtil.trans("entity.paper","보드") }} </span>
                              <span v-if="fromElse.groupKbn == 'USER'" class="cate-tit ell-singleline" 
                                @click="moveLocation('PAPER', fromElse.paperId)">{{ fromElse.paperTitle }}
                              </span>
                            </div>
                            <span class="board_name" v-if="fromElse.commentCount > 1">
                              <button
                                type="button"
                                @click="todoLinkedListModal2Open(fromElse.todoId)"
                              >
                                <b v-if="fromElse.commentCount > 99">99+</b>
                                <b v-else>{{ $i18nUtil.trans("button.data.more","{cnt}건 더보기", {cnt: fromElse.commentCount}) }}</b>
                              </button>
                            </span>
                            <span v-else>
                              <button
                                type="button"
                                class="btn_add black"
                                @click="todoLinkedModal2Open(fromElse.todoId)"
                              >{{$i18nUtil.trans("message.Todo.001","과제 / 보드 연결 설정")}}
                              </button>
                            </span>
                          </div>

                          <div
                            class="list-tit-s multi-ellipsis"
                            @click="todoInfoOpen(fromElse.todoId)"
                          >
                            {{ fromElse.todoTitle }}
                          </div>
                          <div class="btm clear">
                            <div class="re-de fl">
                              <div class="re-de fl">
                                <div class="re">
                                  <div class="droplayer tooltipmember relative">
                                    <v-menu offset-y>
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-btn v-bind="attrs" v-on="on"
                                          ><b>{{
                                            fromElse.regUserName
                                          }}</b></v-btn
                                        >
                                      </template>
                                      <div class="dropdown-list">
                                        <UserTooltip
                                          :userId="fromElse.regUserId"
                                        />
                                      </div>
                                    </v-menu>
                                  </div>
                                </div>
                                <div class="division"></div>
                                <div class="de">
                                  <div class="droplayer tooltipmember relative">
                                    <v-menu offset-y>
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-btn v-bind="attrs" v-on="on"
                                          ><b>{{
                                            fromElse.chargerName
                                          }}</b></v-btn
                                        >
                                      </template>
                                      <div class="dropdown-list">
                                        <UserTooltip
                                          :userId="fromElse.chargerId"
                                        />
                                      </div>
                                    </v-menu>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="list-date fr"
                              :class="
                                $moment($moment(fromElse.todoEndDate).format('YYYY.MM.DD')).diff($moment(new Date()).format('YYYY.MM.DD'), 'days') <= 3
                                  ? 'deadline'
                                  : ''
                              "
                            >
                              ~
                              {{ $moment(fromElse.todoEndDate).format('YYYY.MM.DD') }}
                            </div>
                          </div>
                        </div>
                        <!--//list-->
                        <div class="btn_box txtc">
                          <button
                            type="button"
                            class="btn-more-ico_small1 down"
                            v-if="listFromMeElseCount > listFromMeElse.length"
                            @click="addKanbanList('fromElse')"
                          >
                            {{ $i18nUtil.trans("button.data.more","{cnt}건 더보기", {cnt: listFromMeElseCount - listFromMeElse.length > 5 ? 5 : listFromMeElseCount - listFromMeElse.length}) }}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="inner">
                      <div class="tit">
                        완료 <b>{{ listFromMeEndCount }}</b>
                      </div>
                      <div class="list_wrap">
                        <div class="nodata" v-if="listFromMeEndCount == 0">
                          <div class="txt">{{$i18nUtil.trans("search.031","완료된 할 일이 없습니다.")}}</div>
                        </div>
                        <div
                          class="list"
                          v-for="(fromEnd, index) in listFromMeEnd"
                          :key="'listFromMeEnd' + index"
                          :transfer-data="fromEnd"
                        >
                          <div class="checkbox">
                            <input type="checkbox" checked /><label
                              @click="complete(fromEnd)"
                            ></label>
                          </div>
                          
                          <div class="task_name flex flex-between">
                            <div class="flex-division">
                              <span v-if="fromEnd.groupKbn == 'CFRC' && fromEnd.paperId == ''">{{ $i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의") }} </span>
                              <span v-if="fromEnd.groupKbn == 'CFRC' && fromEnd.paperId == ''" class="cate-tit ell-singleline">{{ fromEnd.categoryName }}</span>
                              <span v-if="fromEnd.groupKbn == 'CFRC' && fromEnd.paperId != ''">{{ $i18nUtil.trans("entity.paper","보드") }} </span>
                              <span v-if="fromEnd.groupKbn == 'CFRC' && fromEnd.paperId != ''" class="cate-tit ell-singleline" 
                                @click="moveLocation('PAPER', fromEnd.paperId)">{{ fromEnd.paperTitle }}
                              </span>
                              <span v-if="fromEnd.groupKbn == 'PRO' && fromEnd.paperId == ''">{{$i18nUtil.trans("entity.project","과제")}} </span>
                              <span v-if="fromEnd.groupKbn == 'PRO' && fromEnd.paperId == ''" class="cate-tit ell-singleline" 
                                @click="moveLocation(fromEnd.groupKbn, fromEnd.projectId)">{{ fromEnd.projectName }}
                              </span>
                              <span v-if="fromEnd.groupKbn == 'PRO' && fromEnd.paperId != ''">{{ $i18nUtil.trans("entity.paper","보드") }} </span>
                              <span v-if="fromEnd.groupKbn == 'PRO' && fromEnd.paperId != ''" class="cate-tit ell-singleline"
                                @click="moveLocation('PAPER', fromEnd.paperId)">{{ fromEnd.paperTitle }}
                              </span>
                              <span v-if="fromEnd.groupKbn == 'USER'">{{ $i18nUtil.trans("entity.paper","보드") }} </span>
                              <span v-if="fromEnd.groupKbn == 'USER'" class="cate-tit ell-singleline" 
                                @click="moveLocation('PAPER', fromEnd.paperId)">{{ fromEnd.paperTitle }}
                              </span>
                            </div>
                            <span class="board_name" v-if="fromEnd.commentCount > 1">
                              <button
                                type="button"
                                @click="todoLinkedListModal2Open(fromEnd.todoId)"
                              >
                                <b v-if="fromEnd.commentCount > 99">99+</b>
                                <b v-else>{{ $i18nUtil.trans("button.data.more","{cnt}건 더보기", {cnt: fromEnd.commentCount}) }}</b>
                              </button>
                            </span>
                            <span v-else>
                              <button
                                type="button"
                                class="btn_add black"
                                @click="todoLinkedModal2Open(fromEnd.todoId)"
                              >{{$i18nUtil.trans("message.Todo.001","과제 / 보드 연결 설정")}}
                              </button>
                            </span>
                          </div>

                          <div
                            class="list-tit-s multi-ellipsis"
                            @click="todoInfoOpen(fromEnd.todoId)"
                          >
                            {{ fromEnd.todoTitle }}
                          </div>
                          <div class="btm clear">
                            <div class="re-de fl">
                              <div class="re-de fl">
                                <div class="re">
                                  <div class="droplayer tooltipmember relative">
                                    <v-menu offset-y>
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-btn v-bind="attrs" v-on="on"
                                          ><b>{{
                                            fromEnd.regUserName
                                          }}</b></v-btn
                                        >
                                      </template>
                                      <div class="dropdown-list">
                                        <UserTooltip
                                          :userId="fromEnd.regUserId"
                                        />
                                      </div>
                                    </v-menu>
                                  </div>
                                </div>
                                <div class="division"></div>
                                <div class="de">
                                  <div class="droplayer tooltipmember relative">
                                    <v-menu offset-y>
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-btn v-bind="attrs" v-on="on"
                                          ><b>{{
                                            fromEnd.chargerName
                                          }}</b></v-btn
                                        >
                                      </template>
                                      <div class="dropdown-list">
                                        <UserTooltip
                                          :userId="fromEnd.chargerId"
                                        />
                                      </div>
                                    </v-menu>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="list-date fr"
                            >
                              {{ $moment(fromEnd.todoEndDate).format('YYYY.MM.DD') }}
                            </div>
                          </div>
                        </div>
                        <div class="btn_box txtc">
                          <button
                            type="button"
                            class="btn-more-ico_small1 down"
                            v-if="listFromMeEndCount > listFromMeEnd.length"
                            @click="addKanbanList('fromEnd')"
                          >
                            {{ $i18nUtil.trans("button.data.more","{cnt}건 더보기", {cnt: listFromMeEndCount - listFromMeEnd.length > 5 ? 5 : listFromMeEndCount - listFromMeEnd.length}) }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="currentTab4 == 1">
                  <div class="tb-header clear">
                    <div class="tb_sort fr">
                      <div class="calendar_box_grp small">
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            v-model="startDate"
                            :disabled-dates="startDisabledDate"
                          ></datepicker>
                        </div>
                        <span>~</span>
                        <div class="calendar_box" style="margin-left: 10px">
                          <datepicker
                            format="yyyy.MM.dd"
                            v-model="endDate"
                            :disabled-dates="endDisabledDate"
                          ></datepicker>
                        </div>
                        <div class="calendar_box hidden"></div>
                      </div>
                      <div class="dividing_line_ty1"></div>
                    </div>
                  </div>
                  <!-- //tb-header -->
                  <div class="scroll">
                    <v-data-table
                      v-model="selected"
                      :headers="headers"
                      :items="listFromFileList"
                      :page.sync="page"
                      :items-per-page="itemsPerPage"
                      @page-count="pageCount = $event"
                      hide-default-footer
                      class="tb-contents uts004_table"
                    >
                      <template v-slot:[`item.chk`]="{ item }">
                        <div class="checkbox">
                          <input type="checkbox" checked v-if="item.todoStatus === 'C'" />
                          <input type="checkbox" v-if="item.todoStatus === 'P'" />
                          <label class="ty2" @click="complete(item)"></label>
                        </div>
                      </template>
                      
                      <template v-slot:[`header.reDe`]="{ header }">
                        <div class="re-de">
                          <div class="re">{{ header.re }}</div>
                          <div class="division"></div>
                          <div class="de">{{ header.de }}</div>
                        </div>
                      </template>

                      <template v-slot:[`item.todo`]="{ item }">
                        <div class="task_name flex flex-between">
                          <div class="flex-division">
                            <span v-if="item.groupKbn == 'CFRC' && item.paperId == ''">{{ $i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의") }} </span>
                            <span v-if="item.groupKbn == 'CFRC' && item.paperId == ''" class="cate-tit ell-singleline">{{ item.categoryName }}</span>
                            <span v-if="item.groupKbn == 'CFRC' && item.paperId != ''">{{ $i18nUtil.trans("entity.paper","보드") }} </span>
                            <span v-if="item.groupKbn == 'CFRC' && item.paperId != ''" class="cate-tit ell-singleline" 
                              @click="moveLocation('PAPER', item.paperId)">{{ item.paperTitle }}
                            </span>
                            <span v-if="item.groupKbn == 'PRO' && item.paperId == ''">{{$i18nUtil.trans("entity.project","과제")}} </span>
                            <span v-if="item.groupKbn == 'PRO' && item.paperId == ''" class="cate-tit ell-singleline" 
                              @click="moveLocation(item.groupKbn, item.projectId)">{{ item.projectName }}
                            </span>
                            <span v-if="item.groupKbn == 'PRO' && item.paperId != ''">{{ $i18nUtil.trans("entity.paper","보드") }} </span>
                            <span v-if="item.groupKbn == 'PRO' && item.paperId != ''" class="cate-tit ell-singleline"
                              @click="moveLocation('PAPER', item.paperId)">{{ item.paperTitle }}
                            </span>
                            <span v-if="item.groupKbn == 'USER'">{{ $i18nUtil.trans("entity.paper","보드") }} </span>
                            <span v-if="item.groupKbn == 'USER'" class="cate-tit ell-singleline" 
                              @click="moveLocation('PAPER', item.paperId)">{{ item.paperTitle }}
                            </span>
                          </div>
                          <span v-show="item.todoStatus != 'D'" class="add" :class="item.addShow">
                            <button type="button" class="btn_add" @click="todoLinkedModal2Open(item.todoId)"
                              >{{$i18nUtil.trans("message.Todo.001","과제 / 보드 연결 설정")}}
                            </button>
                          </span>
                          <span class="board_name" :class="item.nameShow">
                            <button type="button" @click="todoLinkedListModal2Open(item.todoId)">
                              <b v-if="item.num > 99">99+</b>
                              <b v-else>{{ $i18nUtil.trans("button.data.more","{cnt}건 더보기", {cnt: item.num}) }}</b>
                            </button>
                          </span>
                        </div>

                        <div v-if="item.todoStatus === 'D'" class="list-tit-s ell-singleline d-block"
                          >{{ item.todo }}
                        </div>
                        <div v-if="item.todoStatus != 'D'" class="list-tit-s ell-singleline d-block" @click="todoInfoOpen(item.todoId)"
                          >{{ item.todo }}
                        </div>
                      </template>
                      <template v-slot:[`item.reDe`]="{ item }">
                        <div class="re-de">
                          <div class="re">
                            <div class="droplayer tooltipmember relative right">
                              <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on"
                                    ><b>{{ item.re }}</b></v-btn
                                  >
                                </template>
                                <div class="dropdown-list">
                                  <UserTooltip :userId="item.regUserId" />
                                </div>
                              </v-menu>
                            </div>
                          </div>
                          <div class="division"></div>
                          <div class="de">
                            <div class="droplayer tooltipmember relative right">
                              <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on"
                                    ><b>{{ item.de }}</b></v-btn
                                  >
                                </template>
                                <div class="dropdown-list">
                                  <UserTooltip :userId="item.chargerId" />
                                </div>
                              </v-menu>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-slot:[`item.finDate`]="{ item }">
                        <div :class="item.finDateDeadline">
                          {{ item.finDate }}
                        </div>
                      </template>
                      <template slot="no-data">
                        <div class="nodata-txt-noicon">
                          <v-alert :value="true">{{$i18nUtil.trans("search.038","요청한 할 일이 없습니다.")}}</v-alert>
                        </div>
                      </template>
                    </v-data-table>
                    <div class="pagination">
                      <v-pagination
                        v-model="listFromFileListPage"
                        circle
                        :length="pageCountFrom"
                        :total-visible="7"
                        @input="onPageChange('listFromFileList')"
                      ></v-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="currentTab3 == 1">
            <div class="tab_ty2">
              <ul class="tab-menu">
                <li
                  v-for="(tab, index) in tabsTy5"
                  v-bind:class="{ active: currentTab5 === index }"
                  :key="'tabsTy5_' + index"
                >
                  <button type="button" @click="changeTab2(index)">
                    {{ tab }}
                  </button>
                </li>
              </ul>
              <div class="tab-content">
                <div v-show="currentTab5 == 0">
                  <div class="tb-header clear">
                    <div class="tb_sort fr">
                      <div class="calendar_box_grp small">
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            v-model="startDate"
                            :disabled-dates="startDisabledDate"
                          ></datepicker>
                        </div>
                        <span>~</span>
                        <div class="calendar_box" style="margin-left: 10px">
                          <datepicker
                            format="yyyy.MM.dd"
                            v-model="endDate"
                            :disabled-dates="endDisabledDate"
                          ></datepicker>
                        </div>
                        <div class="calendar_box hidden"></div>
                      </div>
                      <div class="dividing_line_ty1"></div>
                    </div>
                  </div>
                  <!-- //tb-header -->
                  <div class="decision-making todo clear col-2">
                    <div class="inner">
                      <div class="tit">
                        미완료
                        <b>{{ listToMeElseCount }}</b>
                      </div>
                      <div class="list_wrap">
                        <div class="nodata" v-if="listToMeElseCount == 0">
                          <div class="txt">{{$i18nUtil.trans("search.029","미완료된 할 일이 없습니다.")}}</div>
                        </div>
                        <div
                          class="list"
                          v-for="(ToElse, index) in listToMeElse"
                          :key="'listToMeElse' + index"
                          :transfer-data="ToElse"
                        >
                          <div class="checkbox">
                            <input type="checkbox" /><label
                              @click="complete(ToElse)"
                            ></label>
                          </div>
                          
                          <div class="task_name flex flex-between">
                            <div class="flex-division">
                              <span v-if="ToElse.groupKbn == 'CFRC' && ToElse.paperId == ''">{{ $i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의") }} </span>
                              <span v-if="ToElse.groupKbn == 'CFRC' && ToElse.paperId == ''" class="cate-tit ell-singleline">{{ ToElse.categoryName }}</span>
                              <span v-if="ToElse.groupKbn == 'CFRC' && ToElse.paperId != ''">{{ $i18nUtil.trans("entity.paper","보드") }} </span>
                              <span v-if="ToElse.groupKbn == 'CFRC' && ToElse.paperId != ''" class="cate-tit ell-singleline" 
                                @click="moveLocation('PAPER', ToElse.paperId)">{{ ToElse.paperTitle }}
                              </span>
                              <span v-if="ToElse.groupKbn == 'PRO' && ToElse.paperId == ''">{{$i18nUtil.trans("entity.project","과제")}} </span>
                              <span v-if="ToElse.groupKbn == 'PRO' && ToElse.paperId == ''" class="cate-tit ell-singleline" 
                                @click="moveLocation(ToElse.groupKbn, ToElse.projectId)">{{ ToElse.projectName }}
                              </span>
                              <span v-if="ToElse.groupKbn == 'PRO' && ToElse.paperId != ''">{{ $i18nUtil.trans("entity.paper","보드") }} </span>
                              <span v-if="ToElse.groupKbn == 'PRO' && ToElse.paperId != ''" class="cate-tit ell-singleline"
                                @click="moveLocation('PAPER', ToElse.paperId)">{{ ToElse.paperTitle }}
                              </span>
                              <span v-if="ToElse.groupKbn == 'USER'">{{ $i18nUtil.trans("entity.paper","보드") }} </span>
                              <span v-if="ToElse.groupKbn == 'USER'" class="cate-tit ell-singleline" 
                                @click="moveLocation('PAPER', ToElse.paperId)">{{ ToElse.paperTitle }}
                              </span>
                            </div>
                            <span class="board_name" v-if="ToElse.commentCount > 1">
                              <button
                                type="button"
                                @click="todoLinkedListModal2Open(ToElse.todoId)"
                              >
                                <b v-if="ToElse.commentCount > 99">99+</b>
                                <b v-else>{{ $i18nUtil.trans("button.data.more","{cnt}건 더보기", {cnt: ToElse.commentCount}) }}</b>
                              </button>
                            </span>
                            <span v-else>
                              <button
                                type="button"
                                class="btn_add black"
                                @click="todoLinkedModal2Open(ToElse.todoId)"
                              >{{$i18nUtil.trans("message.Todo.001","과제 / 보드 연결 설정")}}
                              </button>
                            </span>
                          </div>

                          <div
                            class="list-tit-s multi-ellipsis"
                            @click="todoInfoOpen(ToElse.todoId)"
                          >
                            {{ ToElse.todoTitle }}
                          </div>
                          <div class="btm clear">
                            <div class="re-de fl">
                              <div class="re-de fl">
                                <div class="re">
                                  <div class="droplayer tooltipmember relative">
                                    <v-menu offset-y>
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-btn v-bind="attrs" v-on="on"
                                          ><b>{{
                                            ToElse.regUserName
                                          }}</b></v-btn
                                        >
                                      </template>
                                      <div class="dropdown-list">
                                        <UserTooltip
                                          :userId="ToElse.regUserId"
                                        />
                                      </div>
                                    </v-menu>
                                  </div>
                                </div>
                                <div class="division"></div>
                                <div class="de">
                                  <div class="droplayer tooltipmember relative">
                                    <v-menu offset-y>
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-btn v-bind="attrs" v-on="on"
                                          ><b>{{
                                            ToElse.chargerName
                                          }}</b></v-btn
                                        >
                                      </template>
                                      <div class="dropdown-list">
                                        <UserTooltip
                                          :userId="ToElse.chargerId"
                                        />
                                      </div>
                                    </v-menu>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="list-date fr"
                              :class="
                                $moment($moment(ToElse.todoEndDate).format('YYYY.MM.DD')).diff($moment(new Date()).format('YYYY.MM.DD'), 'days') <= 3
                                  ? 'deadline'
                                  : ''
                              "
                            >
                              ~
                              {{ $moment(ToElse.todoEndDate).format('YYYY.MM.DD') }}
                            </div>
                          </div>
                        </div>
                        <!--//list-->
                        <div class="btn_box txtc">
                          <button
                            type="button"
                            class="btn-more-ico_small1 down"
                            v-if="listToMeElseCount > listToMeElse.length"
                            @click="addKanbanList('toElse')"
                          >
                            {{ $i18nUtil.trans("button.data.more","{cnt}건 더보기", {cnt: listToMeElseCount - listToMeElse.length > 5 ? 5 : listToMeElseCount - listToMeElse.length}) }}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="inner">
                      <div class="tit">
                        완료 <b>{{ listToMeEndCount }}</b>
                      </div>
                      <div class="list_wrap">
                        <div class="nodata" v-if="listToMeEndCount == 0">
                          <div class="txt">{{$i18nUtil.trans("search.031","완료된 할 일이 없습니다.")}}</div>
                        </div>
                        <div
                          class="list"
                          v-for="(ToEnd, index) in listToMeEnd"
                          :key="'listToMeEnd' + index"
                          :transfer-data="ToEnd"
                        >
                          <div class="checkbox">
                            <input type="checkbox" checked /><label
                              @click="complete(ToEnd)"
                            ></label>
                          </div>

                          <div class="task_name flex flex-between">
                            <div class="flex-division">
                              <span v-if="ToEnd.groupKbn == 'CFRC' && ToEnd.paperId == ''">{{ $i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의") }} </span>
                              <span v-if="ToEnd.groupKbn == 'CFRC' && ToEnd.paperId == ''" class="cate-tit ell-singleline">{{ ToEnd.categoryName }}</span>
                              <span v-if="ToEnd.groupKbn == 'CFRC' && ToEnd.paperId != ''">{{ $i18nUtil.trans("entity.paper","보드") }} </span>
                              <span v-if="ToEnd.groupKbn == 'CFRC' && ToEnd.paperId != ''" class="cate-tit ell-singleline" 
                                @click="moveLocation('PAPER', ToEnd.paperId)">{{ ToEnd.paperTitle }}
                              </span>
                              <span v-if="ToEnd.groupKbn == 'PRO' && ToEnd.paperId == ''">{{$i18nUtil.trans("entity.project","과제")}} </span>
                              <span v-if="ToEnd.groupKbn == 'PRO' && ToEnd.paperId == ''" class="cate-tit ell-singleline" 
                                @click="moveLocation(ToEnd.groupKbn, ToEnd.projectId)">{{ ToEnd.projectName }}
                              </span>
                              <span v-if="ToEnd.groupKbn == 'PRO' && ToEnd.paperId != ''">{{ $i18nUtil.trans("entity.paper","보드") }} </span>
                              <span v-if="ToEnd.groupKbn == 'PRO' && ToEnd.paperId != ''" class="cate-tit ell-singleline"
                                @click="moveLocation('PAPER', ToEnd.paperId)">{{ ToEnd.paperTitle }}
                              </span>
                              <span v-if="ToEnd.groupKbn == 'USER'">{{ $i18nUtil.trans("entity.paper","보드") }} </span>
                              <span v-if="ToEnd.groupKbn == 'USER'" class="cate-tit ell-singleline" 
                                @click="moveLocation('PAPER', ToEnd.paperId)">{{ ToEnd.paperTitle }}
                              </span>
                            </div>
                            <span class="board_name" v-if="ToEnd.commentCount > 1">
                              <button
                                type="button"
                                @click="todoLinkedListModal2Open(ToEnd.todoId)"
                              >
                                <b v-if="ToEnd.commentCount > 99">99+</b>
                                <b v-else>{{ $i18nUtil.trans("button.data.more","{cnt}건 더보기", {cnt: ToEnd.commentCount}) }}</b>
                              </button>
                            </span>
                            <span v-else>
                              <button
                                type="button"
                                class="btn_add black"
                                @click="todoLinkedModal2Open(ToEnd.todoId)"
                              >{{$i18nUtil.trans("message.Todo.001","과제 / 보드 연결 설정")}}
                              </button>
                            </span>
                          </div>

                          <div
                            class="list-tit-s multi-ellipsis"
                            @click="todoInfoOpen(ToEnd.todoId)"
                          >
                            {{ ToEnd.todoTitle }}
                          </div>
                          <div class="btm clear">
                            <div class="re-de fl">
                              <div class="re-de fl">
                                <div class="re">
                                  <div class="droplayer tooltipmember relative">
                                    <v-menu offset-y>
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-btn v-bind="attrs" v-on="on"
                                          ><b>{{ ToEnd.regUserName }}</b></v-btn
                                        >
                                      </template>
                                      <div class="dropdown-list">
                                        <UserTooltip
                                          :userId="ToEnd.regUserId"
                                        />
                                      </div>
                                    </v-menu>
                                  </div>
                                </div>
                                <div class="division"></div>
                                <div class="de">
                                  <div class="droplayer tooltipmember relative">
                                    <v-menu offset-y>
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-btn v-bind="attrs" v-on="on"
                                          ><b>{{ ToEnd.chargerName }}</b></v-btn
                                        >
                                      </template>
                                      <div class="dropdown-list">
                                        <UserTooltip
                                          :userId="ToEnd.chargerId"
                                        />
                                      </div>
                                    </v-menu>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="list-date fr"
                            >
                              {{ $moment(ToEnd.todoEndDate).format('YYYY.MM.DD') }}
                            </div>
                          </div>
                        </div>
                        <div class="btn_box txtc">
                          <button
                            type="button"
                            class="btn-more-ico_small1 down"
                            v-if="listToMeEndCount > listToMeEnd.length"
                            @click="addKanbanList('toEnd')"
                          >
                            {{ $i18nUtil.trans("button.data.more","{cnt}건 더보기", {cnt: listToMeEndCount - listToMeEnd.length > 5 ? 5 : listToMeEndCount - listToMeEnd.length}) }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="currentTab5 == 1">
                  <div class="tb-header clear">
                    <div class="tb_sort fr">
                      <div class="calendar_box_grp small">
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            v-model="startDate"
                            :disabled-dates="startDisabledDate"
                          ></datepicker>
                        </div>
                        <span>~</span>
                        <div class="calendar_box" style="margin-left: 10px">
                          <datepicker
                            format="yyyy.MM.dd"
                            v-model="endDate"
                            :disabled-dates="endDisabledDate"
                          ></datepicker>
                        </div>
                        <div class="calendar_box hidden"></div>
                      </div>
                      <div class="dividing_line_ty1"></div>
                    </div>
                  </div>
                  <!-- //tb-header -->
                  <div class="scroll">
                    <v-data-table
                      v-model="selected"
                      :headers="headers"
                      :items="listToFileList"
                      :page.sync="page"
                      :items-per-page="itemsPerPage"
                      @page-count="pageCount = $event"
                      hide-default-footer
                      class="tb-contents uts004_table"
                    >
                      <template v-slot:[`item.chk`]="{ item }">
                        <div class="checkbox">
                          <input type="checkbox" checked v-if="item.todoStatus === 'C'" />
                          <input type="checkbox" v-if="item.todoStatus === 'P'" />
                          <label class="ty2" @click="complete(item)"></label>
                        </div>
                      </template>
                      
                      <template v-slot:[`header.reDe`]="{ header }">
                        <div class="re-de">
                          <div class="re">{{ header.re }}</div>
                          <div class="division"></div>
                          <div class="de">{{ header.de }}</div>
                        </div>
                      </template>

                      <template v-slot:[`item.todo`]="{ item }">
                        <div class="task_name flex flex-between">
                          <div class="flex-division">
                            <span v-if="item.groupKbn == 'CFRC' && item.paperId == ''">{{ $i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의") }} </span>
                            <span v-if="item.groupKbn == 'CFRC' && item.paperId == ''" class="cate-tit ell-singleline">{{ item.categoryName }}</span>
                            <span v-if="item.groupKbn == 'CFRC' && item.paperId != ''">{{ $i18nUtil.trans("entity.paper","보드") }} </span>
                            <span v-if="item.groupKbn == 'CFRC' && item.paperId != ''" class="cate-tit ell-singleline" 
                              @click="moveLocation('PAPER', item.paperId)">{{ item.paperTitle }}
                            </span>
                            <span v-if="item.groupKbn == 'PRO' && item.paperId == ''">{{$i18nUtil.trans("entity.project","과제")}} </span>
                            <span v-if="item.groupKbn == 'PRO' && item.paperId == ''" class="cate-tit ell-singleline" 
                              @click="moveLocation(item.groupKbn, item.projectId)">{{ item.projectName }}
                            </span>
                            <span v-if="item.groupKbn == 'PRO' && item.paperId != ''">{{ $i18nUtil.trans("entity.paper","보드") }} </span>
                            <span v-if="item.groupKbn == 'PRO' && item.paperId != ''" class="cate-tit ell-singleline"
                              @click="moveLocation('PAPER', item.paperId)">{{ item.paperTitle }}
                            </span>
                            <span v-if="item.groupKbn == 'USER'">{{ $i18nUtil.trans("entity.paper","보드") }} </span>
                            <span v-if="item.groupKbn == 'USER'" class="cate-tit ell-singleline" 
                              @click="moveLocation('PAPER', item.paperId)">{{ item.paperTitle }}
                            </span>
                          </div>
                          <span v-show="item.todoStatus != 'D'" class="add" :class="item.addShow">
                            <button type="button" class="btn_add" @click="todoLinkedModal2Open(item.todoId)"
                              >{{$i18nUtil.trans("message.Todo.001","과제 / 보드 연결 설정")}}
                            </button>
                          </span>
                          <span class="board_name" :class="item.nameShow">
                            <button type="button" @click="todoLinkedListModal2Open(item.todoId)">
                              <b v-if="item.num > 99">99+</b>
                              <b v-else>{{ $i18nUtil.trans("button.data.more","{cnt}건 더보기", {cnt: item.num}) }}</b>
                            </button>
                          </span>
                        </div>

                        <div v-if="item.todoStatus === 'D'" class="list-tit-s ell-singleline d-block"
                          >{{ item.todo }}
                        </div>
                        <div v-if="item.todoStatus != 'D'" class="list-tit-s ell-singleline d-block" @click="todoInfoOpen(item.todoId)"
                          >{{ item.todo }}
                        </div>
                      </template>
                      <template v-slot:[`item.reDe`]="{ item }">
                        <div class="re-de">
                          <div class="re">
                            <div class="droplayer tooltipmember relative right">
                              <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on"
                                    ><b>{{ item.re }}</b></v-btn
                                  >
                                </template>
                                <div class="dropdown-list">
                                  <UserTooltip :userId="item.regUserId" />
                                </div>
                              </v-menu>
                            </div>
                          </div>
                          <div class="division"></div>
                          <div class="de">
                            <div class="droplayer tooltipmember relative right">
                              <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on"
                                    ><b>{{ item.de }}</b></v-btn
                                  >
                                </template>
                                <div class="dropdown-list">
                                  <UserTooltip :userId="item.chargerId" />
                                </div>
                              </v-menu>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-slot:[`item.finDate`]="{ item }">
                        <div :class="item.finDateDeadline">
                          {{ item.finDate }}
                        </div>
                      </template>
                      <template slot="no-data">
                        <div class="nodata-txt-noicon">
                          <v-alert :value="true">{{$i18nUtil.trans("search.033","요청받은 할 일이 없습니다.")}}</v-alert>
                        </div>
                      </template>
                    </v-data-table>
                    <div class="pagination">
                      <v-pagination
                        v-model="listToFileListPage"
                        circle
                        :length="pageCountTo"
                        :total-visible="7"
                        @input="onPageChange('listToFileList')"
                      ></v-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modals-container @updateTodoList="initTabSelect"> </modals-container>
  </div>
</template>
<script>
import todoInfo from "@/components/cowork/general/board/todo/popup/TodoInfo.vue";
import todoLinkedModal2 from "./TodoLinkedModal2.vue";
import todoLinkedListModal2 from "./TodoLinkedListModal2.vue";
import Datepicker from "vuejs-datepicker";
import EventBus from "@/js/eventbus/eventBus";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";

export default {
  components: {
    Datepicker,
    UserTooltip,
  },
  data() {
    /* tenantId */
    let tenantId = localStorage.getItem("tenantId");
    return {
      tenantId: tenantId,
      ellipsisTimer: null,
      date: "2020.12.31",
      currentTab3: 0,
      currentTab4: 0,
      currentTab5: 0,
      tabsTy3: [this.$i18nUtil.trans("title.Todo.tab3.001","요청한 할 일"), this.$i18nUtil.trans("title.Todo.tab3.002","요청받은 할 일")],
      tabsTy4: [this.$i18nUtil.trans("title.Todo.tab4.001","칸반"), this.$i18nUtil.trans("title.Todo.tab4.002","리스트")],
      tabsTy5: [this.$i18nUtil.trans("title.Todo.tab5.001","칸반"), this.$i18nUtil.trans("title.Todo.tab5.002","리스트")],
      show: "true",
      hide: "false",

      page: 1,
      listFromFileListPage: 1,
      listToFileListPage: 1,
      pageCount: 0,
      pageCountTo: 0,
      pageCountFrom: 0,
      itemsPerPage: 20,
      singleSelect: false,
      selected: [],
      headers: [
        { text: "", value: "chk", sortable: false },
        { text: this.$i18nUtil.trans("entity.todo.content","할 일 내용"), value: "todo", sortable: false },
        {
          re: this.$i18nUtil.trans("entity.todo.requester","요청자"),
          align: "center",
          de: this.$i18nUtil.trans("entity.todo.personInCharge","담당자"),
          value: "reDe",
          sortable: false,
        },
        { text: this.$i18nUtil.trans("entity.todo.filter.lastUpdDate","생성/수정일"), align: "center", value: "newDate", sortable: false },
        { text: this.$i18nUtil.trans("entity.todo.filter.expirationDate","만료일"), align: "center", value: "finDate", sortable: false },
        { text: this.$i18nUtil.trans("entity.todo.filter.completionDate","완료일"), align: "center", value: "terDate", sortable: false },
      ],

      paperId: this.$route.params.paperId,

      userInfo: {},
      listToFileList: [],
      listFromFileList: [],
      startDate: new Date(this.$moment().subtract(7, "days")),
      endDate: new Date(this.$moment()),
      startDisabledDate: {
        from: new Date(this.$moment())
      },
      endDisabledDate: {
        to: new Date(this.$moment().subtract(8, "days"))
      },

      listToData: null,
      listFromData: null,

      listToMeElse: [],
      listToMeEnd: [],
      listFromMeElse: [],
      listFromMeEnd: [],
      listToMeElseCount: 0,
      listToMeEndCount: 0,
      listFromMeElseCount: 0,
      listFromMeEndCount: 0,

      kanban: {
        listToMeElse: [],
        listToMeEnd: [],
        listFromMeElse: [],
        listFromMeEnd: [],
      },

      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },
  watch: {
    startDate() {
      this.setDisabledDate();
      this.initTabSelect();
    },
    endDate() {
      this.setDisabledDate();
      this.initTabSelect();
    },
  },
  mounted() {
    this.multiElipsis(2);
    this.listMineAll();
    this.getUserInfo();
  },
  created() {
    EventBus.$on("refreshTodoBoard", (payload) => {
      this.initTabSelect();
    });
  },
  methods: {
    ...mapActions("modals", ["showToast", "showModal"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    listMineAll() {
      let obj = this;
      let reqData = {};
      obj.kanban.listFromMeElse = [];
      obj.kanban.listFromMeEnd = [];
      reqData.params = {
        startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
        endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
        paperId: this.paperId,
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/todo/listMineAllBoard";
      reqData.method = "post";

      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        let res = response.result;
        this.listFromMeElse = res.listFromMeElse;
        this.listFromMeEnd = res.listFromMeEnd;
        this.listFromMeElseCount = res.listFromMeElseCount;
        this.listFromMeEndCount = res.listFromMeEndCount;
      });
    },
    listFromMeBoard() {
      let obj = this;
      let reqData = {};
      reqData.params = {
        startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
        endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
        paperId: this.paperId,
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/todo/listFromMeBoard";
      reqData.method = "post";

      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        let res = response.result;
        this.listFromData = res.listFromMePlus;
        this.pageCountFrom = res.pageCountFrom;

        obj.listFromSort();
      });
    },
    listToMeBoardKanban() {
      let obj = this;
      let reqData = {};
      obj.kanban.listToMeElse = [];
      obj.kanban.listToMeEnd = [];
      reqData.params = {
        startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
        endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
        paperId: this.paperId,
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/todo/listToMeBoardKanban";
      reqData.method = "post";

      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        let res = response.result;
        this.listToMeElse = res.listToMeElse;
        this.listToMeEnd = res.listToMeEnd;
        this.listToMeElseCount = res.listToMeElseCount;
        this.listToMeEndCount = res.listToMeEndCount;
      });
    },
    listToMeBoard() {
      let obj = this;
      let reqData = {};
      reqData.params = {
        startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
        endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
        paperId: this.paperId,
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/todo/listToMeBoard";
      reqData.method = "post";

      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        let res = response.result;
        this.listToData = res.listToMePlus;
        this.pageCountTo = res.pageCountTo;

        obj.listToSort();
      });
    },
    kanbanSortAll() {
      this.kanban.listToMeElse = [];
      this.kanban.listToMeEnd = [];
      this.kanban.listFromMeElse = [];
      this.kanban.listFromMeEnd = [];
      this.kanbanSort(this.listToMeElse, "listToMeElse");
      this.kanbanSort(this.listToMeEnd, "listToMeEnd");
      this.kanbanSort(this.listFromMeElse, "listFromMeElse");
      this.kanbanSort(this.listFromMeEnd, "listFromMeEnd");
    },
    listToSort() {
      let listTo = this.listToData;
      let listForm = {};
      let today = new Date();
      this.listToFileList = [];

      for (let i = 0; i < listTo.length; i++) {
        listForm = {
          id: null,
          todoId: null,
          re: "",
          de: "",
          task: "",
          sapce: "",
          addShow: "",
          nameShow: "",
          boardName: "",
          num: "",
          todo: "",
          newDate: "",
          finDate: "",
          finDateDeadline: "",
          delDate: "",
          linkedTargetId: [],
          todoStatus: "",
          projectId: "",
          projectName: "",
          paperId: "",
          paperTitle: "",
          categoryName: "",
          groupKbn: "",
          terDate: ""
        };
        listForm.id = i + "listToFileList";
        listForm.todoId = listTo[i].todoId;
        listForm.re = listTo[i].regUserName;
        listForm.de = listTo[i].chargerName;
        listForm.todoStatus = listTo[i].todoStatus;
        listForm.projectId = listTo[i].projectId;
        listForm.projectName = listTo[i].projectName;
        listForm.paperId = listTo[i].paperId;
        listForm.paperTitle = listTo[i].paperTitle;
        listForm.categoryName = listTo[i].categoryName;
        listForm.groupKbn = listTo[i].groupKbn;
        if (listTo[i].groupKbn == "PRO") {
          listForm.task = this.$i18nUtil.trans("entity.project","과제");
        } else if (listTo[i].groupKbn == "USER") {
          listForm.task = this.$i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗");
        } else if (listTo[i].groupKbn == "CFRC") {
          listForm.task = this.$i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의"); // "회의/협의";
        }
        listForm.sapce = listTo[i].projectName;
        if (listTo[i].commentCount < 2) {
          listForm.addShow = "show";
          listForm.nameShow = "";
          listForm.boardName = "";
          listForm.num = "";
        } else {
          listForm.addShow = "";
          listForm.nameShow = "show";
          listForm.boardName = listTo[i].paperTitle;
          listForm.num = listTo[i].commentCount;
        }
        listForm.todo = listTo[i].todoTitle;
        listForm.newDate = this.$moment(listTo[i].regDate).format('YYYY.MM.DD');
        listForm.finDate =
          "~" +
          this.$moment(listTo[i].todoEndDate).format('YYYY.MM.DD');
        
        if (listTo[i].terDate != null) {
          listForm.terDate = this.$moment(listTo[i].terDate).format('YYYY.MM.DD');
        } else {
          var betweenDay =
            this.$moment(this.$moment(listTo[i].todoEndDate).format('YYYY.MM.DD')).diff(this.$moment(new Date()).format('YYYY.MM.DD'), 'days');
          if (betweenDay <= 3) {
            listForm.finDateDeadline = "deadline";
            listTo[i].finDateDeadline = "deadline";
          }
        }
        listForm.regUserId = listTo[i].regUserId;
        listForm.chargerId = listTo[i].chargerId;

        this.listToFileList.push(listForm);
      }
    },
    listFromSort() {
      let listFrom = this.listFromData;
      let listForm = {};
      let today = new Date();
      this.listFromFileList = [];

      for (let i = 0; i < listFrom.length; i++) {
        listForm = {
          id: null,
          todoId: "",
          re: "",
          de: "",
          task: "",
          sapce: "",
          addShow: "",
          nameShow: "",
          boardName: "",
          num: "",
          todo: "",
          newDate: "",
          finDate: "",
          finDateDeadline: "",
          delDate: "",
          linkedTargetId: [],
          todoStatus: "",
          projectId: "",
          projectName: "",
          paperId: "",
          paperTitle: "",
          categoryName: "",
          groupKbn: "",
          terDate: ""
        };
        listForm.id = i + "listFromFileList";
        listForm.todoId = listFrom[i].todoId;
        listForm.re = listFrom[i].regUserName;
        listForm.de = listFrom[i].chargerName;
        listForm.todoStatus = listFrom[i].todoStatus;
        listForm.projectId = listFrom[i].projectId;
        listForm.projectName = listFrom[i].projectName;
        listForm.paperId = listFrom[i].paperId;
        listForm.paperTitle = listFrom[i].paperTitle;
        listForm.categoryName = listFrom[i].categoryName;
        listForm.groupKbn = listFrom[i].groupKbn;
        if (listFrom[i].groupKbn == "PRO") {
          listForm.task = this.$i18nUtil.trans("entity.project","과제");
        } else if (listFrom[i].groupKbn == "USER") {
          listForm.task = this.$i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗");
        } else if (listFrom[i].groupKbn == "CFRC") {
          listForm.task = this.$i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의");
        }
        listForm.sapce = listFrom[i].projectName;
        if (listFrom[i].commentCount < 2) {
          listForm.addShow = "show";
          listForm.nameShow = "";
          listForm.boardName = "";
          listForm.num = "";
        } else {
          listForm.addShow = "";
          listForm.nameShow = "show";
          listForm.boardName = listFrom[i].paperTitle;
          listForm.num = listFrom[i].commentCount;
        }
        listForm.todo = listFrom[i].todoTitle;
        listForm.newDate = this.$moment(listFrom[i].regDate).format('YYYY.MM.DD');
        listForm.finDate =
          "~" +
          this.$moment(listFrom[i].todoEndDate).format('YYYY.MM.DD');
        
        if (listFrom[i].terDate != null) {
          listForm.terDate = this.$moment(listFrom[i].terDate).format('YYYY.MM.DD');
        } else {
          var betweenDay =
            this.$moment(this.$moment(listFrom[i].todoEndDate).format('YYYY.MM.DD')).diff(this.$moment(new Date()).format('YYYY.MM.DD'), 'days');
          if (betweenDay <= 3) {
            listForm.finDateDeadline = "deadline";
            listFrom[i].finDateDeadline = "deadline";
          }
        }
        listForm.regUserId = listFrom[i].regUserId;
        listForm.chargerId = listFrom[i].chargerId;

        this.listFromFileList.push(listForm);
      }
    },
    kanbanSort(param, param2) {
      for (let i = 0; i < param.length; i++) {
        if (param2 === "listToMeElse") {
          this.kanban.listToMeElse.push(param[i]);
        } else if (param2 === "listToMeEnd") {
          this.kanban.listToMeEnd.push(param[i]);
        } else if (param2 === "listFromMeElse") {
          this.kanban.listFromMeElse.push(param[i]);
        } else if (param2 === "listFromMeEnd") {
          this.kanban.listFromMeEnd.push(param[i]);
        }
      }
    },
    complete(param) {
      let para = { todoId: param.todoId };
      let complete = "/api/copaper/todo/complete";

      this.$axios.post(complete, para).then((response) => {
        if (param.todoStatus === "P") {
          this.toastInfo.message = this.$i18nUtil.trans("TB020");
        } else if (param.todoStatus === "C") {
          this.toastInfo.message = this.$i18nUtil.trans("TB021");
        }
        this.showToast(this.toastInfo);
        this.initTabSelect();
      });
    },
    getUserInfo() {
      let userInfo = "/api/copaper/decision/userInfo";
      this.$axios.post(userInfo).then((response) => {
        this.userInfo = response.data.result;
      });
    },

    todoModalOpen() {
      const modalInfo = {
        name: "todoAddModal",
        obj: this.$modal,
        component: todoAddModal,
        width: "800px",
        // height: "800px",
        userInfo: this.userInfo,
      };
      this.showModal(modalInfo);
    },
    todoLinkedModal2Open(param) {
      const modalInfo = {
        name: "todoLinkedModal2",
        obj: this.$modal,
        component: todoLinkedModal2,
        width: "800px",
    //    height: "516px",
        userInfo: this.userInfo,
        todoId: param,
      };
      this.showModal(modalInfo);
    },
    todoLinkedListModal2Open(param) {
      const modalInfo = {
        name: "todoLinkedListModal2",
        obj: this.$modal,
        component: todoLinkedListModal2,
        width: "800px",
        height: "495px",
        todoId: param,
      };
      this.showModal(modalInfo);
    },
    todoInfoOpen(param) {
      const modalInfo = {
        name: "todoInfo",
        obj: this.$modal,
        component: todoInfo,
        width: "800px",
        // height: "615px",
        todoId: param,
      };
      this.showModal(modalInfo);
    },
    replaceAll(str, input, output) {
      return str.split(input).join(output);
    },
    // setDisabledDate() {
    //   this.startDisabledDate.from = this.endDate;
    //   this.endDisabledDate.to = this.startDate;
    // },
    onPageChange(param) {
      let obj = this;
      if (param === "listFromFileList") {
        let reqData = {};
        reqData.params = {
          startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
          endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
          pagingNo: this.listFromFileListPage,
          paperId: this.paperId,
        };
        reqData.req = obj.req;
        reqData.url = "/api/copaper/todo/listFromUserBoardPaging";
        reqData.method = "post";
        obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
          let res = response.result;
          this.listFromData = res.listFromMeBoard;
          this.listFromSort();
        });
      } else if (param === "listToFileList") {
        let obj = this;
        let reqData = {};
        reqData.params = {
          startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
          endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
          pagingNo: this.listToFileListPage,
          paperId: this.paperId,
        };
        reqData.req = obj.req;
        reqData.url = "/api/copaper/todo/listToUserBoardPaging";
        reqData.method = "post";
        obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
          let res = response.result;
          this.listToData = res.listToMeBoard;
          this.listToSort();
        });
      }
    },
    addKanbanList(param) {
      let obj = this;
      let addDate = [];
      let reqData = {};
      reqData.req = obj.req;
      reqData.url = "/api/copaper/todo/addKanbanListBoard";
      reqData.method = "post";

      if (param === "fromElse") {
        reqData.params = {
          startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
          endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
          pagingNo: this.listFromMeElse.length,
          kanbanName: param,
          paperId: this.paperId,
        };
        obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
          let res = response.result;
          addDate = res.listFromMeElse;
          for (let i = 0; i < addDate.length; i++) {
            this.listFromMeElse.push(addDate[i]);
          }
          this.listFromMeElseCount = res.listFromMeElseCount;
          this.kanbanSort(addDate, "listFromMeElse");
        });
      } else if (param === "fromEnd") {
        reqData.params = {
          startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
          endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
          pagingNo: this.listFromMeEnd.length,
          kanbanName: param,
          paperId: this.paperId,
        };
        obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
          let res = response.result;
          addDate = res.listFromMeEnd;
          for (let i = 0; i < addDate.length; i++) {
            this.listFromMeEnd.push(addDate[i]);
          }
          this.listFromMeEndCount = res.listFromMeEndCount;
          this.kanbanSort(addDate, "listFromMeEnd");
        });
      } else if (param === "toElse") {
        reqData.params = {
          startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
          endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
          pagingNo: this.listToMeElse.length,
          kanbanName: param,
          paperId: this.paperId,
        };
        obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
          let res = response.result;
          addDate = res.listToMeElse;
          for (let i = 0; i < addDate.length; i++) {
            this.listToMeElse.push(addDate[i]);
          }
          this.listToMeElseCount = res.listToMeElseCount;
          this.kanbanSort(addDate, "listToMeElse");
        });
      } else if (param === "toEnd") {
        reqData.params = {
          startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
          endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
          pagingNo: this.listToMeEnd.length,
          kanbanName: param,
          paperId: this.paperId,
        };
        obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
          let res = response.result;
          addDate = res.listToMeEnd;
          for (let i = 0; i < addDate.length; i++) {
            this.listToMeEnd.push(addDate[i]);
          }
          this.listToMeEndCount = res.listToMeEndCount;
          this.kanbanSort(addDate, "listToMeEnd");
        });
      }
    },
    setDisabledDate() {
      this.startDisabledDate.from = this.endDate;
      this.endDisabledDate.to = this.startDate;
    },
    changeTab(index) {
      if(this.currentTab3 === index) return;
      this.currentTab3 = index;
      if (index === 0) {
        this.currentTab4 = '';
        this.changeTab2(0);
      } else {
        this.currentTab5 = '';
        this.changeTab2(0);
      }
    },
    changeTab2(index) {
      if (this.currentTab3 === 0) {
        if(this.currentTab4 === index) return;
        this.currentTab4 = index;

        this.page = 1;
        this.listFromFileListPage = 1;
        this.listToFileListPage = 1;
        this.pageCount = 0;
        this.pageCountTo = 0;
        this.pageCountFrom = 0;
        this.listToFileList = [];
        this.listFromFileList = [];
        this.listToData = null;
        this.listFromData = null;
        this.listToMeElse = [];
        this.listToMeEnd = [];
        this.listFromMeElse = [];
        this.listFromMeEnd = [];
        this.listToMeElseCount = 0;
        this.listToMeEndCount = 0;
        this.listFromMeElseCount = 0;
        this.listFromMeEndCount = 0;

        if (index === 0) {
          //칸반
          this.listMineAll();
        } else if (index === 1) {
          //리스트
          this.listFromMeBoard();
        }
      } else {
        if(this.currentTab5 === index) return;
        this.currentTab5 = index;

        this.page = 1;
        this.listFromFileListPage = 1;
        this.listToFileListPage = 1;
        this.pageCount = 0;
        this.pageCountTo = 0;
        this.pageCountFrom = 0;
        this.listToFileList = [];
        this.listFromFileList = [];
        this.listToData = null;
        this.listFromData = null;
        this.listToMeElse = [];
        this.listToMeEnd = [];
        this.listFromMeElse = [];
        this.listFromMeEnd = [];
        this.listToMeElseCount = 0;
        this.listToMeEndCount = 0;
        this.listFromMeElseCount = 0;
        this.listFromMeEndCount = 0;

        if (index === 0) {
          //칸반
          this.listToMeBoardKanban();
        } else if (index === 1) {
          //리스트
          this.listToMeBoard();
        }
      }
    },
    // 전체탭 초기화후 현재탭 조회
    initTabSelect() {
      this.page = 1;
      this.listFromFileListPage = 1;
      this.listToFileListPage = 1;
      this.pageCount = 0;
      this.pageCountTo = 0;
      this.pageCountFrom = 0;
      this.listToFileList = [];
      this.listFromFileList = [];
      this.listToData = null;
      this.listFromData = null;
      this.listToMeElse = [];
      this.listToMeEnd = [];
      this.listFromMeElse = [];
      this.listFromMeEnd = [];
      this.listToMeElseCount = 0;
      this.listToMeEndCount = 0;
      this.listFromMeElseCount = 0;
      this.listFromMeEndCount = 0;

      if (this.currentTab3 === 0) {
        if (this.currentTab4 === 0) {
          //칸반
          this.listMineAll();
        } else if (this.currentTab4 === 1) {
          //리스트
          this.listFromMeBoard();
        }
      } else {
        if (this.currentTab5 === 0) {
          //칸반
          this.listToMeBoardKanban();
        } else if (this.currentTab5 === 1) {
          //리스트
          this.listToMeBoard();
        }
      }
    },
    multiElipsis(ellipsisLine) {
      if (this.ellipsisTimer) {
        clearTimeout(this.ellipsisTimer);
      }

      this.ellipsisTimer = setTimeout(function () {
        if ($(".multi-ellipsis").length > 0) {
          var omle = $(".multi-ellipsis");
          var $txtR = $("<div class='txtEllipsis'></div>");
          var $body = $("body");
          omle.each(function (idx) {
            var _this = $(this);
            var orinalWidth = $(this).width();
            var txtOmle = _this.text();

            $txtR.text(txtOmle);
            $body.append($txtR);

            if ($txtR.width() >= orinalWidth * 1.2) {
              _this.addClass("no-ellipsis");
            } else {
              _this.removeClass("no-ellipsis");
            }
          });
        }
      }, 250);

      setTimeout(function () {
        $(".txtEllipsis").remove();
      }, 1000);
    },
    moveLocation(type, location) {
      if (type == "PRO") {
        window.open("/general/dashboard/" + location, "_blank");
      }
      if (type == "PAPER") {
        window.open("/general/board/" + location, "_blank");
      }
    },
  },
};
</script>
<style scoped>
.txtEllipsis {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.multi-ellipsis {
  overflow: hidden;
  position: relative;
  min-height: 23px;
  max-height: 2.8em;
  line-height: 1.4;
  text-align: justify;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}
.multi-ellipsis:before,
.multi-ellipsis:after {
  content: "...";
  line-height: 1;
  position: absolute;
  right: 0;
  top: 1.6em;
  -ms-wrap-flow: start;
}
.multi-ellipsis:after {
  background: currentColor !important;
  color: #fff !important;
  top: auto;
}
.multi-ellipsis.no-ellipsis::before,
.multi-ellipsis.no-ellipsis::after {
  display: none;
}
@supports (-webkit-line-clamp: 2) {
  .multi-ellipsis {
    -webkit-box-orient: vertical;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
  }
  .multi-ellipsis::before,
  .multi-ellipsis::after {
    content: normal;
  }
}
.uts004 .nodata {
    height: calc(100% - 17px);
}
.cate-tit {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/todo/popup/Todo.vue